interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-8" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 bg-background-50 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line mr-0.5"></i>上一页
      </button>
      {pages.map((p, idx) =>
        typeof p === 'number' ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${p === current ? 'bg-primary-500 text-background-50' : 'bg-background-50 border border-background-200 text-foreground-700 hover:border-primary-300'}`}
          >
            {p}
          </button>
        ) : (
          <span key={`e-${idx}`} className="w-9 h-9 flex items-center justify-center text-foreground-400">…</span>
        ),
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 bg-background-50 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页<i className="ri-arrow-right-s-line ml-0.5"></i>
      </button>
    </nav>
  );
}